import(/* webpackMode: "eager", webpackExports: ["CancelIlustration"] */ "/app/apps/team-leagues/src/components/illustrations/CancelIlustration.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TLTicker"] */ "/app/apps/team-leagues/src/components/molecules/ticker/TLTicker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BallsSection"] */ "/app/apps/team-leagues/src/components/organisms/BallsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BaseMarketingSection"] */ "/app/apps/team-leagues/src/components/organisms/BaseMarketingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DistrictList"] */ "/app/apps/team-leagues/src/components/organisms/DistrictList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DivisionInfoData"] */ "/app/apps/team-leagues/src/components/organisms/DivisionInfoData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedLeagues"] */ "/app/apps/team-leagues/src/components/organisms/FeaturedLeagues.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GameStatsTable"] */ "/app/apps/team-leagues/src/components/organisms/GameStatsTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GameStatsTableWrapper"] */ "/app/apps/team-leagues/src/components/organisms/GameStatsTableWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeaguesPastFutureFilter"] */ "/app/apps/team-leagues/src/components/organisms/LeaguesPastFutureFilter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainHeader"] */ "/app/apps/team-leagues/src/components/organisms/MainHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MLPCarousel"] */ "/app/apps/team-leagues/src/components/organisms/MLPCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalWrapper"] */ "/app/apps/team-leagues/src/components/organisms/ModalWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TradePlayerWrapper"] */ "/app/apps/team-leagues/src/components/organisms/player-movements/TradePlayerWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlayerLeaguesList"] */ "/app/apps/team-leagues/src/components/organisms/PlayerLeaguesList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecommendedLeagues"] */ "/app/apps/team-leagues/src/components/organisms/RecommendedLeagues.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScoreCardsLayout"] */ "/app/apps/team-leagues/src/components/organisms/ScoreCards/ScoreCardsLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LineupViewSkeleton"] */ "/app/apps/team-leagues/src/components/organisms/skeletons/LineupViewSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScoreViewSkeleton"] */ "/app/apps/team-leagues/src/components/organisms/skeletons/ScoreViewSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SponsorsList"] */ "/app/apps/team-leagues/src/components/organisms/SponsorsList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamInfoData"] */ "/app/apps/team-leagues/src/components/organisms/TeamInfoData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamLeagueDetailsCards"] */ "/app/apps/team-leagues/src/components/organisms/TeamLeagueDetailsCards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TransactionsTable"] */ "/app/apps/team-leagues/src/components/organisms/TransactionsTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamLeagueDetailsLayoutContent"] */ "/app/apps/team-leagues/src/components/pages/TeamLeagueDetailsLayoutContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.28_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.64.1_@types_3e72b95ceafbd8d17b62a1c8d6ead12b/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.28_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.64.1_@types_3e72b95ceafbd8d17b62a1c8d6ead12b/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/packages/features/src/error-pages/error-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainHeader"] */ "/app/packages/ui/src/components/global/Header/MainHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RTEProvider"] */ "/app/packages/ui/src/components/global/RTEProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/packages/ui/src/components/ui/button.tsx");
